module.exports = __webpack_public_path__ + "static/media/side-arrow.64118c19.svg";